// extracted by mini-css-extract-plugin
export default {"thumbsUp":"ResponseFeedbackDialog-module__thumbsUp--mkxCd","thumbsDown":"ResponseFeedbackDialog-module__thumbsDown--kNUc2"};